import { useState } from 'react';
import { useClient } from 'jsonapi-react';

// Cache dos detalhamentos (arquivos/atividades/apostilas) por módulo, usado
// pelos cards playful de módulo. Só é preenchido quando algum dos botões de um
// módulo é clicado; módulos já buscados ficam guardados aqui e não são
// buscados de novo. Só se perde em reload da página (é apenas estado em
// memória). Compartilhado entre a tela do aluno e a do professor.
export function useModuleDetailsCache() {
  const client = useClient();
  const [moduleDetails, setModuleDetails] = useState({});
  const [loadingDetailsFor, setLoadingDetailsFor] = useState({});

  const fetchModuleDetails = async moduleId => {
    if (moduleDetails[moduleId] || loadingDetailsFor[moduleId]) return;
    setLoadingDetailsFor(prev => ({ ...prev, [moduleId]: true }));
    const { data } = await client.fetch(`/learning_systems/${moduleId}?detailed=true`);
    setModuleDetails(prev => ({
      ...prev,
      [moduleId]: {
        files: data?.['learning-system-files'] || [],
        activities: data?.['learning-system-activities']?.map(item => item.activity) || [],
        booklets: data?.['learning-system-question-books'] || []
      }
    }));
    setLoadingDetailsFor(prev => ({ ...prev, [moduleId]: false }));
  };

  return { moduleDetails, loadingDetailsFor, fetchModuleDetails };
}
